<template>

  <div v-if="customFieldGroups">
    <div
      v-for="(group, index) in customFieldGroups"
      :key="index">
      <div class="card mb-4">
        <div class="card-header">
          {{ group.name }}
        </div>
        <div class="card-body">

          <div
            class="form-group"
            v-for="(field, field_index) in group.custom_fields"
            :key="field_index">
            <label class="control-label">
              <span v-if="field.required">*</span>
              {{ field.label }}
            </label>
            <input-custom-field
              :type = "field.type"
              :options = "field.options"
              v-model="custom_fields[field.key]">
              </input-custom-field>
            <ValidateMessage
              :error="validateErrors['custom_fields.' + field.key]" />
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import InputCustomField from '@/components/Fields/InputCustomField'

export default {
  name: 'CustomForm',
  components: {
    InputCustomField
  },
  props: [
    'initCustomFields',
    'validateErrors',
    'modelType'
  ],
  data () {
    return {
      custom_fields: this.$clone(this.initCustomFields || {}),
      customFieldGroups: false
    }
  },
  watch: {
    custom_fields: {
      handler: function (newValue) {
        this.$emit('changed', newValue)
      },
      deep: true
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    }
  },
  created () {
    const availableFeature = this.resourceAvailability.features.includes('custom_fields')
    if (availableFeature) {
      this.loadCustomFields()
    } else {
      this.customFieldGroups = []
    }
  },
  methods: {
    loadCustomFields () {
      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/custom-field-groups?sort=position&model_type=' + this.modelType)
      .then((response) => {
        this.customFieldGroups = response.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/CustomForm.vue